(function () {
  if (window.__slSignupLoaded) return;
  window.__slSignupLoaded = true;

  var MC_HOST = 'https://sarah-linda.us11.list-manage.com';
  var MC_U    = '3259686441933721e86f2f6c8';
  var MC_ID   = 'da165bc903';
  // "consumers" tag — required for the welcome-journey automation to fire.
  var MC_TAG_ID = '139029';

  var TEXT = {
    working: 'Sending…',
    successHtml:
      '<p class="sl-signup__message-title">Thank you!</p>' +
      '<p class="sl-signup__message-body">You will receive an email with your discount code. ' +
      'If you don\'t see it, please check your spam.<br>' +
      'I look forward to staying in touch!<br>' +
      'Sarah-Linda</p>',
    already: 'You are already on the list.',
    noName:  'Please enter your first name.',
    invalid: 'Please enter a valid email address.',
    failed:  'Something went wrong. Please try again.'
  };

  // Same cookie the theme's own popup component reads on mount to decide
  // whether to show at all (uv.get('sl-newsletter-popup-hide')). Setting it
  // ourselves — with our own duration — overrides the theme's default here.
  var POPUP_HIDE_COOKIE = 'sl-newsletter-popup-hide';
  function setPopupHideCookie(days) {
    document.cookie = POPUP_HIDE_COOKIE + '=true; max-age=' + (days * 24 * 60 * 60) + '; path=/';
  }

  // The theme's built-in close button always hides the popup for 365 days.
  // We want that only for an actual subscribe; a plain close should be much
  // shorter, so re-set the cookie right after the theme's own handler runs.
  function wireClosePopupCookie() {
    var btn = document.querySelector('.newsletter-popup__close-button');
    if (!btn || btn.dataset.slPopupCloseWired) return;
    btn.dataset.slPopupCloseWired = '1';
    btn.addEventListener('click', function () { setPopupHideCookie(1); });
  }

  // Mailchimp sends no CORS headers, so JSONP is the only way to submit in
  // the background and keep the visitor on the page.
  function send(email, firstName, trapName) {
    return new Promise(function (resolve, reject) {
      var cb = 'slmc_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
      var s = document.createElement('script');
      var t = setTimeout(function () { done(); reject(new Error('timeout')); }, 10000);

      function done() {
        clearTimeout(t);
        try { delete window[cb]; } catch (e) { window[cb] = undefined; }
        if (s.parentNode) s.parentNode.removeChild(s);
      }

      window[cb] = function (d) { done(); resolve(d); };
      s.onerror = function () { done(); reject(new Error('network')); };

      s.src = MC_HOST + '/subscribe/post-json'
        + '?u=' + encodeURIComponent(MC_U)
        + '&id=' + encodeURIComponent(MC_ID)
        + '&EMAIL=' + encodeURIComponent(email)
        + '&FNAME=' + encodeURIComponent(firstName)
        + '&tags=' + encodeURIComponent(MC_TAG_ID)
        + '&' + encodeURIComponent(trapName) + '='
        + '&c=' + cb;

      document.body.appendChild(s);
    });
  }

  function wire(form) {
    if (form.dataset.slWired) return;
    form.dataset.slWired = '1';

    var root    = form.closest('.sl-signup');
    var intro   = root.querySelector('[data-sl-intro]');
    var success = root.querySelector('[data-sl-success]');
    var email   = form.querySelector('input[name="EMAIL"]');
    var fname   = form.querySelector('input[name="FNAME"]');
    var trap    = form.querySelector('.sl-signup__trap input');
    var button  = form.querySelector('.sl-signup__button');
    var label   = form.querySelector('[data-sl-label]');
    var msg     = form.querySelector('[data-sl-message]');
    var idle    = label.textContent;

    function say(text, state) {
      msg.textContent = text;
      msg.setAttribute('data-state', state || 'info');
    }
    // Success replaces the whole intro (heading/body/form) with a thank-you
    // message in the same space, rather than showing it alongside the form.
    function showSuccess(html) {
      intro.hidden = true;
      success.innerHTML = html;
      success.hidden = false;
      // Subscribing from the popup itself should stop it reappearing for a
      // year — longer than a plain close, since this visitor is now a subscriber.
      if (root.classList.contains('sl-signup--popup')) { setPopupHideCookie(365); }
    }
    function busy(on) {
      button.disabled = on;
      label.textContent = on ? TEXT.working : idle;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var first = (fname.value || '').trim();
      var mail  = (email.value || '').trim();

      if (!first) {
        fname.setAttribute('aria-invalid', 'true'); say(TEXT.noName, 'error'); fname.focus(); return;
      }
      fname.removeAttribute('aria-invalid');

      if (!mail || !email.checkValidity()) {
        email.setAttribute('aria-invalid', 'true'); say(TEXT.invalid, 'error'); email.focus(); return;
      }
      email.removeAttribute('aria-invalid');

      // Filled honeypot means a bot. Fake success, send nothing.
      if (trap.value !== '') { showSuccess(TEXT.successHtml); return; }

      busy(true); say('', 'info');

      send(mail, first, trap.name).then(function (data) {
        busy(false);

        var ok = data && data.result === 'success';
        if (!ok && /already subscribed/i.test((data && data.msg) || '')) { say(TEXT.already, 'info'); return; }

        if (!ok) {
          var raw = ((data && data.msg) || '').replace(/<[^>]*>/g, '').trim();
          say(raw || TEXT.failed, 'error');
          return;
        }

        form.reset();
        showSuccess(TEXT.successHtml);

        // Hand off to the Shopify custom pixel for the Pinterest conversion.
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('newsletter_signup', {
              email: mail,
              first_name: first,
              event_id: 'sl-' + Date.now() + '-' + Math.floor(Math.random() * 1e6),
              source: form.closest('.sl-signup--popup') ? 'popup' : 'landing-section'
            });
          }
        } catch (err) { /* tracking must never break the signup itself */ }
      }).catch(function () {
        busy(false);
        say(TEXT.failed, 'error');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sl-signup]').forEach(wire);
    wireClosePopupCookie();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Popups often inject late, and the theme editor re-renders sections.
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 1500);
  setTimeout(init, 4000);
})();
